import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

import { translate } from 'services/i18nService';

import singleCoin from '../../../../../../../../images/chat/single-coin.png';

import styles from './index.css';


const mapping = {
  '1': '20',
  '2': '100',
  '3': '250',
  '4': '500',
};

const RecentSpendingTierIndicator = (props) => {
  const {
    hasTokens,
    recentSpendingTier,
  } = props;

  const hasIconsIconElement = useMemo(() => {
    if (!hasTokens) {
      return null;
    }

    return (
      <img
        alt="tokens"
        className={styles.icon}
        src={singleCoin}
      />
    );
  }, [hasTokens]);

  if (!recentSpendingTier && !hasTokens) {
    return null;
  }

  const classes = classNames({
    [styles.recentSpendingTierIndicator]: true,
    [styles.tierWhite]: recentSpendingTier === 0,
    [styles.tierBlue]: recentSpendingTier === 1,
    [styles.tierPurple]: recentSpendingTier === 2,
    [styles.tierYellow]: recentSpendingTier === 3,
    [styles.tierOrange]: recentSpendingTier === 4,
  });

  const total = mapping[recentSpendingTier.toString()];

  let tooltipText = undefined;
  if (hasTokens) {
    if (recentSpendingTier === 0) {
      tooltipText = translate('v2broadcast.user.has.tokens');
    } else {
      tooltipText = translate('v2broadcast.spending.tier.has.tokens', { 0: total });
    }
  } else if (recentSpendingTier > 0) {
    tooltipText = translate('v2broadcast.spending.tier.no.tokens', { 0: total });
  }

  return (
    <Tooltip
      arrow={true}
      placement="top"
      title={tooltipText}
    >
      <div className={classes}>
        {hasIconsIconElement}
      </div>
    </Tooltip>
  );
};

RecentSpendingTierIndicator.propTypes = {
  hasTokens: PropTypes.bool,
  recentSpendingTier: PropTypes.number,
};

RecentSpendingTierIndicator.defaultProps = {
  hasTokens: false,
  recentSpendingTier: undefined,
};

export default RecentSpendingTierIndicator;
